import React, { useState, useRef, useEffect } from "react";

// Define the vacation types as a hardcoded array
const vacationTypes = [
  { code: "STD", name: "Standard" },
  { code: "FAM", name: "Family" },
  { code: "HON", name: "Honeymoon" },
  { code: "SUR", name: "Surfing" },
  { code: "DVG", name: "Diving" },
];

// Define the props type for the component
interface VacationTypeDropdownProps {
  selectedVacationType: string;
  handleVacationTypeChange: (value: string) => void;
}

const VacationTypeDropdown: React.FC<VacationTypeDropdownProps> = ({
  selectedVacationType,
  handleVacationTypeChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Toggle dropdown open/close
  const toggleDropdown = () => setIsOpen(!isOpen);

  // Handle option click
  const handleOptionClick = (code: string) => {
    handleVacationTypeChange(code);
    setIsOpen(false);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Find the selected vacation type name
  const selectedVacationName =
    vacationTypes.find((v) => v.code === selectedVacationType)?.name ||
    "Select Vacation Type";

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
  type="button"
  onClick={toggleDropdown}
  className="w-full min-w-[130px] max-w-full rounded bg-white md:p-1 focus:outline-none md:px-4 py-2 text-left flex items-center text-[14px]"
  aria-haspopup="listbox"
  aria-expanded={isOpen}
>
  {selectedVacationName}
  <svg
    className="ml-1 mt-0.5 w-4 h-4"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="#dc0069"
    aria-hidden="true"
  >
    <polygon points="12,16 6,8 18,8" />
  </svg>
</button>
      {isOpen && (
        <ul
          className="absolute z-10 bg-white border border-gray-300 rounded-md shadow-lg w-full max-h-60 overflow-y-auto mt-1 scrollbar-initial"
          style={{ minWidth: "110px" }}
          role="listbox"
          tabIndex={-1}
        >
          {vacationTypes.map((vacationType) => (
            <li
              key={vacationType.code}
              onClick={() => handleOptionClick(vacationType.code)}
              className={`px-4 py-2 cursor-pointer hover:bg-halo-pink-bg hover:text-halo-pink text-[14px] ${selectedVacationType === vacationType.code ? "bg-halo-pink-bg text-halo-pink" : ""
                }`}
              role="option"
              aria-selected={selectedVacationType === vacationType.code}
            >
              {vacationType.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default VacationTypeDropdown;